var map = {
	"./Icons_AdjustBrightnessContrast.svg": 14035,
	"./Icons_Adminisration.svg": 3852,
	"./Icons_BlueArrowDown.svg": 83169,
	"./Icons_BlueArrowUp.svg": 66865,
	"./Icons_CaseInformation.svg": 20529,
	"./Icons_ChangeReviewStatus.svg": 81448,
	"./Icons_CircleLeftBlue.svg": 74165,
	"./Icons_CircleLeftGrey.svg": 89506,
	"./Icons_CircleLeftLeftBlue.svg": 61939,
	"./Icons_CircleLeftLeftGrey.svg": 30391,
	"./Icons_CircleRightBlue.svg": 92919,
	"./Icons_CircleRightGrey.svg": 87598,
	"./Icons_CircleRightRightBlue.svg": 14255,
	"./Icons_CircleRightRightGrey.svg": 81430,
	"./Icons_ClearDrawings_Blue.svg": 71634,
	"./Icons_ClearDrawings_Orange.svg": 8467,
	"./Icons_Comments.svg": 75197,
	"./Icons_DefaultView.svg": 29151,
	"./Icons_Delete.svg": 58502,
	"./Icons_DrawFreehand_Blue.svg": 86368,
	"./Icons_DrawFreehand_Orange.svg": 77041,
	"./Icons_DrawLooped_Blue.svg": 59955,
	"./Icons_DrawLooped_Orange.svg": 40271,
	"./Icons_Edit.svg": 39059,
	"./Icons_EditorialBoardBox.svg": 92937,
	"./Icons_ExportTSV.svg": 32208,
	"./Icons_Filter.svg": 92122,
	"./Icons_Folder.svg": 66051,
	"./Icons_FullPageView.svg": 51252,
	"./Icons_HideToLeftWhite.svg": 94870,
	"./Icons_HideToRightBlue.svg": 29221,
	"./Icons_ListMode.svg": 2954,
	"./Icons_ListModeSelected.svg": 85173,
	"./Icons_MoveBackForRevision.svg": 33820,
	"./Icons_MoveBackToEditorialBoardBox.svg": 56492,
	"./Icons_MoveToEditorBox.svg": 84475,
	"./Icons_MoveToEditorialBoardBox.svg": 125,
	"./Icons_MoveToPrepublicationBox.svg": 23346,
	"./Icons_MoveToPublicAccessBox.svg": 93305,
	"./Icons_MyFolders.svg": 30316,
	"./Icons_NavigationTool.svg": 82317,
	"./Icons_OpenedFolder.svg": 90163,
	"./Icons_PersonalSlideBox.svg": 8829,
	"./Icons_PrePublicationBox.svg": 80718,
	"./Icons_PreviewMode.svg": 24067,
	"./Icons_PreviewModeSelected.svg": 38090,
	"./Icons_ProjectConfiguration.svg": 77154,
	"./Icons_PublicAccessBox.svg": 83693,
	"./Icons_Search.svg": 66542,
	"./Icons_SecondaryArrowDown.svg": 57354,
	"./Icons_SharedByContributors.svg": 75461,
	"./Icons_Sreenshot.svg": 12929,
	"./Icons_Subscriptions.svg": 96686,
	"./Icons_Users.svg": 8365,
	"./Icons_ViewCaseImageAndInfo.svg": 16616,
	"./Icons_ViewSlidesInfo.svg": 85622,
	"./Icons_WebSiteContent.svg": 91902,
	"./Icons_WebpageView.svg": 42059,
	"./Icons_ZoomTool.svg": 40582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87930;